<template>
  <div class="side-menu fill-height">
    <v-navigation-drawer permanent color="transparent" stateless>
      <v-list-item>
        <v-list-item-content class="pa-0 pb-2">
          <v-row no-gutters class="pt-2" align="center">
            <v-col v-if="$vuetify.breakpoint.lgAndUp">
              <v-list-item-title
                class="text-h6 text-right d-flex justify-start"
              >
                <v-img
                  content-class="d-flex"
                  :src="
                    getLogo('desktop', 'top') || $store.state.imgLogoDefault
                  "
                  max-height="60"
                  max-width="80"
                  contain
                />
              </v-list-item-title>
            </v-col>
            <v-col>
              <v-list-item-subtitle class="text-sm-left text-lg-right">
                <div class="text-caption">{{ $t("bem_vindo") }}</div>
                <div>
                  <small> {{ $t("painel_usuario") }}</small>
                </div>
              </v-list-item-subtitle>
            </v-col>
            <v-col v-if="$vuetify.breakpoint.mdAndDown">
              <v-list-item-title class="text-h6 text-left d-flex justify-end">
                <v-img
                  content-class="d-flex"
                  :src="getLogo('mobile', 'top') || $store.state.imgLogoDefault"
                  max-height="60"
                  max-width="80"
                  contain
                />
              </v-list-item-title>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item
        v-if="!this.$store.state.auth.user.token"
        class="pa-0 pl-2 pr-lg-2"
        style="max-width: 256px"
      >
        <v-list-item-avatar
          v-if="
            $vuetify.breakpoint.mdAndDown &&
            userData('fotoPerfil') === '::restrict::'
          "
          size="45"
          class="text-h6 text-right d-flex justify-end"
        >
          <v-icon
            style="position: absolute; top: -2px; left: -15px; opacity: 0.65"
            size="13"
          >
            mdi-lock
          </v-icon>
          <v-img style="opacity: 0.4" src="/img/person-avatar.png" />
        </v-list-item-avatar>
        <v-list-item-avatar
          v-if="
            $vuetify.breakpoint.mdAndDown &&
            userData('fotoPerfil') !== '::restrict::'
          "
          size="45"
          class="text-h6 text-right d-flex justify-end"
        >
          <v-img
            :src="
              !userData('fotoPerfil')
                ? '/img/person-avatar.png'
                : userData('fotoPerfil')
            "
          />
        </v-list-item-avatar>
        <v-list-item class="pa-0">
          <restrict-chip-list-item :value="userData('nome')">
            <v-list-item-content>
              <v-list-item-title
                class="text-subtitle-2 text-lg-right text-truncate"
                :title="userData('nome')"
                style="width: 1px"
              >
                {{ userData("nome") || $t("sem_nome") | toPT_BRCapitalize }}
              </v-list-item-title>
              <restrict-chip-list-item :value="userData('email')">
                <v-list-item-subtitle
                  class="caption text-lg-right text-truncate"
                  :title="userData('email')"
                  style="width: 1px"
                >
                  {{ userData("email") }}
                </v-list-item-subtitle>
              </restrict-chip-list-item>
            </v-list-item-content>
          </restrict-chip-list-item>
        </v-list-item>
        <v-list-item-avatar
          v-if="
            $vuetify.breakpoint.lgAndUp &&
            userData('fotoPerfil') === '::restrict::'
          "
          size="45"
          class="text-h6 text-right d-flex justify-end"
        >
          <v-icon
            style="position: absolute; top: -2px; left: -15px; opacity: 0.65"
            size="13"
          >
            mdi-lock
          </v-icon>
          <v-img style="opacity: 0.4" src="/img/person-avatar.png" />
        </v-list-item-avatar>
        <v-list-item-avatar
          v-if="
            $vuetify.breakpoint.lgAndUp &&
            userData('fotoPerfil') !== '::restrict::'
          "
          size="45"
          class="text-h6 text-right d-flex justify-end"
        >
          <v-img
            :src="
              !userData('fotoPerfil')
                ? '/img/person-avatar.png'
                : userData('fotoPerfil')
            "
          />
        </v-list-item-avatar>
      </v-list-item>

      <v-menu v-if="$store.state.auth.user.token" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item
            :ripple="false"
            v-bind="attrs"
            v-on="on"
            class="pa-0 pl-2 pr-lg-2"
            style="max-width: 256px"
            @click="onGetAccounts"
          >
            <v-list-item-avatar
              v-if="
                $vuetify.breakpoint.mdAndDown &&
                userData('fotoPerfil') === '::restrict::'
              "
              size="45"
              class="text-h6 text-right d-flex justify-end"
            >
              <v-icon
                style="
                  position: absolute;
                  top: -2px;
                  left: -15px;
                  opacity: 0.65;
                "
                size="13"
              >
                mdi-lock
              </v-icon>
              <v-img style="opacity: 0.4" src="/img/person-avatar.png" />
            </v-list-item-avatar>
            <v-list-item-avatar
              v-if="
                $vuetify.breakpoint.mdAndDown &&
                userData('fotoPerfil') !== '::restrict::'
              "
              size="45"
              class="text-h6 text-right d-flex justify-end"
            >
              <v-img
                :src="
                  !userData('fotoPerfil')
                    ? '/img/person-avatar.png'
                    : userData('fotoPerfil')
                "
              />
            </v-list-item-avatar>
            <v-list-item class="pa-0">
              <restrict-chip-list-item :value="userData('nome')">
                <v-list-item-content>
                  <v-list-item-title
                    class="text-subtitle-2 text-lg-right text-truncate"
                    :title="userData('nome')"
                    style="width: 1px"
                  >
                    {{ userData("nome") || $t("sem_nome") | toPT_BRCapitalize }}
                  </v-list-item-title>
                  <restrict-chip-list-item :value="userData('email')">
                    <v-list-item-subtitle
                      class="caption text-lg-right text-truncate"
                      :title="userData('email')"
                      style="width: 1px"
                    >
                      {{ userData("email") }}
                    </v-list-item-subtitle>
                  </restrict-chip-list-item>
                </v-list-item-content>
              </restrict-chip-list-item>
            </v-list-item>
            <v-list-item-avatar
              v-if="
                $vuetify.breakpoint.lgAndUp &&
                userData('fotoPerfil') === '::restrict::'
              "
              size="45"
              class="text-h6 text-right d-flex justify-end"
            >
              <v-icon
                style="
                  position: absolute;
                  top: -2px;
                  left: -15px;
                  opacity: 0.65;
                "
                size="13"
              >
                mdi-lock
              </v-icon>
              <v-img style="opacity: 0.4" src="/img/person-avatar.png" />
            </v-list-item-avatar>
            <v-list-item-avatar
              v-if="
                $vuetify.breakpoint.lgAndUp &&
                userData('fotoPerfil') !== '::restrict::'
              "
              size="45"
              class="text-h6 text-right d-flex justify-end"
            >
              <v-img
                :src="
                  !userData('fotoPerfil')
                    ? '/img/person-avatar.png'
                    : userData('fotoPerfil')
                "
              />
            </v-list-item-avatar>
          </v-list-item>
        </template>

        <v-list dense style="max-height: 360px; overflow: hidden auto">
          <!-- Pessoa -->
          <div
            v-if="getAccounts.pessoa.length > 0"
            class="px-3 grey lighten-3 text-center pa-0"
            style="position: sticky; top: -8px; width: 100%; z-index: 1"
          >
            <span
              class="
                text-uppercase
                caption
                font-weight-bold
                grey--text
                text--darken-1
                pa-0
                ma-0
              "
              style="font-size: 9px !important; line-height: 3"
            >
              {{
                getAccounts.pessoa.length > 1
                  ? $t("braceletes")
                  : $t("bracelete")
              }}
            </span>
          </div>
          <v-list-item
            v-for="(item, i) in getAccounts.pessoa"
            :key="'pessoa-' + i"
            link
            class="menu-item py-2"
            @click="onLoginAccount(item.uid, item.tipo)"
          >
            <v-list-item-title>
              <v-list-item-title>
                {{ item.nome | toPT_BRCapitalize }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                <span style="font-size: 10px">
                  {{ "ID: " + getID(item.uid) }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-title>
            <v-list-item-icon
              class="
                menu-item-icon-open
                d-flex
                align-center
                justify-center
                pt-2
              "
            >
              <v-icon size="16">mdi-open-in-new</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <!-- Pet -->
          <div
            v-if="getAccounts.pet.length > 0"
            class="px-3 grey lighten-3 text-center pa-0"
            style="position: sticky; top: -8px; width: 100%; z-index: 1"
          >
            <span
              class="
                text-uppercase
                caption
                font-weight-bold
                grey--text
                text--darken-1
                pa-0
                ma-0
              "
              style="font-size: 9px !important"
            >
              {{
                getAccounts.pet.length > 1 ? $t("pingentes") : $t("pingente")
              }}
            </span>
          </div>
          <v-list-item
            v-for="(item, i) in getAccounts.pet"
            :key="'pet-' + i"
            link
            class="menu-item py-2"
            @click="onLoginAccount(item.uid, item.tipo)"
          >
            <v-list-item-title>
              <v-list-item-title>
                {{ item.nome | toPT_BRCapitalize }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                <span style="font-size: 10px">
                  {{ "ID: " + getID(item.uid) }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-title>
            <v-list-item-icon
              class="
                menu-item-icon-open
                d-flex
                align-center
                justify-center
                pt-2
              "
            >
              <v-icon size="16">mdi-open-in-new</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <!-- Tag -->
          <div
            v-if="getAccounts.tag.length > 0"
            class="px-3 grey lighten-3 text-center pa-0"
            style="position: sticky; top: -8px; width: 100%; z-index: 1"
          >
            <span
              class="
                text-uppercase
                caption
                font-weight-bold
                grey--text
                text--darken-1
                pa-0
                ma-0
              "
              style="font-size: 9px !important; line-height: 3"
            >
              tag
            </span>
          </div>
          <v-list-item
            v-for="(item, i) in getAccounts.tag"
            :key="'tag-' + i"
            link
            class="menu-item py-2"
            @click="onLoginAccount(item.uid, item.tipo)"
          >
            <v-list-item-title>
              <v-list-item-title>
                {{ item.nome | toPT_BRCapitalize }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                <span style="font-size: 10px">
                  {{ "ID: " + getID(item.uid) }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-title>
            <v-list-item-icon
              class="
                menu-item-icon-open
                d-flex
                align-center
                justify-center
                pt-2
              "
            >
              <v-icon size="16">mdi-open-in-new</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <!-- Status Accounts -->
          <v-list-item
            v-if="$store.state.auth.statusAccounts === 1"
            style="width: 100%; background-color: #fff"
          >
            <v-progress-circular
              indeterminate
              size="10"
              width="1"
              class="mr-2 grey--text"
            />
            <i class="caption grey--text">{{ $t("atualizando") }}</i>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in menu"
          :key="item.title"
          :to="item.to"
          exact
          link
          class="text-lg-right"
          @click="onClickMenuItem"
        >
          <v-list-item-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="mr-sm-3"
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon v-if="$vuetify.breakpoint.lgAndUp">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <template #append>
        <div class="">
          <v-divider></v-divider>
          <div
            class="
              pa-2
              text-center text-lg-right
              d-flex
              justify-space-between
              align-end
            "
          >
            <div v-if="isLogged" class="d-none d-md-block">
              <v-img
                content-class="d-flex"
                :src="getLogo('desktop', 'bottom') || ''"
                max-height="60"
                max-width="80"
                contain
              />
            </div>
            <div
              class="d-flex justify-space-between flex-grow-1 flex-lg-grow-0"
            >
              <v-menu offset-y v-if="$vuetify.breakpoint.width < 1260">
                <template #activator="{ on, attrs }">
                  <v-btn
                    text
                    color="secondary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="pa-2 py-3 d-lg-none"
                    height="0"
                  >
                    <div class="pr-3">
                      <v-img
                        width="20"
                        :src="'/lang/flags/' + $store.state.language + '.svg'"
                      />
                    </div>
                    <small>{{ $store.state.language.replace("_", "-") }}</small>
                    <div class="pl-1">
                      <v-icon small>mdi-menu-down</v-icon>
                    </div>
                  </v-btn>
                </template>
                <v-list min-width="100">
                  <v-list-item
                    v-for="(item, i) in $store.state.languages"
                    :key="i"
                    @click="onChangeLanguage(item.flag)"
                  >
                    <v-list-item-title
                      class="d-flex align-center justify-start"
                    >
                      <div class="pr-3">
                        <v-img
                          width="20"
                          :src="'/lang/flags/' + item.flag + '.svg'"
                        />
                      </div>
                      <div>
                        <small>{{ item.lang }}</small>
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div v-if="isLogged">
                <v-btn link elevation="0" small @click="onLogout">
                  <span class="caption text-capitalize mr-2">{{
                    $t("sair")
                  }}</span>
                  <v-icon size="16" color="grey darken-2">mdi-export</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import i18next from "i18next";
import RestrictChipListItem from "@/components/chips/restrict-chip-list-item";

export default {
  components: { RestrictChipListItem },
  props: {
    onClickMenuItem: {
      default: () => {},
      type: Function,
    },
    imgLogo: {
      type: String,
    },
  },
  data: () => ({
    menuPessoa: [],
    menuPet: [],
    menuTag: [],
    menuAdminPessoa: [],
    menuAdminPet: [],
    menuAdminTag: [],
    right: null,
    accountsUpdated: false,
  }),
  watch: {
    "$store.state.statusLoadTranslate"(next, prev) {
      if (prev === "loading" && next === "loaded") {
        this.menuPessoa = [
          {
            title: i18next.t("Perfil"),
            icon: "mdi-card-account-details",
            to: "/",
          },
          {
            title: i18next.t("Dados_Pessoais"),
            icon: "mdi-account",
            to: "/details",
          },
          {
            title: i18next.t("Dados_Fisicos"),
            icon: "mdi-human-handsdown",
            to: "/physical-details",
          },
          {
            title: i18next.t("Dados_Sanguineos"),
            icon: "mdi-water",
            to: "/blood-details",
          },
          {
            title: i18next.t("Medicamentos"),
            icon: "mdi-pill",
            to: "/medicaments",
          },
          {
            title: i18next.t("Doencas"),
            icon: "mdi-emoticon-sick",
            to: "/diseases",
          },
          {
            title: i18next.t("Cart_Vacinacao"),
            icon: "mdi-needle",
            to: "/vaccination",
          },
          {
            title: i18next.t("Prontuario_Medico"),
            icon: "mdi-clipboard-plus",
            to: "/medical-record",
          },
          {
            title: i18next.t("Outras_Informacoes"),
            icon: "mdi-information-variant",
            to: "/informations",
          },
        ];

        this.menuPet = [
          {
            title: i18next.t("Perfil"),
            icon: "mdi-card-account-details",
            to: "/pet",
          },
          {
            title: i18next.t("Dados_Pet"),
            icon: "mdi-dog",
            to: "/pet/details",
          },
          {
            title: i18next.t("Dados_Fisicos"),
            icon: "mdi-dog-side",
            to: "/pet/physical-details",
          },
          {
            title: i18next.t("Dados_Alimentacao"),
            icon: "mdi-bone",
            to: "/pet/fooding",
          },
          {
            title: i18next.t("Medicamentos"),
            icon: "mdi-pill",
            to: "/pet/medicaments",
          },
          {
            title: i18next.t("Doencas"),
            icon: "mdi-emoticon-sick",
            to: "/pet/diseases",
          },
          {
            title: i18next.t("Cart_Vacinacao"),
            icon: "mdi-needle",
            to: "/pet/vaccination",
          },
          {
            title: i18next.t("Prontuario_Medico"),
            icon: "mdi-clipboard-plus",
            to: "/pet/medical-record",
          },
          {
            title: i18next.t("Outras_Informacoes"),
            icon: "mdi-information-variant",
            to: "/pet/informations",
          },
        ];

        this.menuTag = [
          {
            title: i18next.t("Perfil"),
            icon: "mdi-card-account-details",
            to: "/tag",
          },
          {
            title: i18next.t("Funcionario"),
            icon: "mdi-account-tie",
            to: "/tag/employee",
          },
          {
            title: i18next.t("Dados_Pessoais"),
            icon: "mdi-account",
            to: "/tag/details",
          },
          {
            title: i18next.t("Dados_Fisicos"),
            icon: "mdi-human-handsdown",
            to: "/tag/physical-details",
          },
          {
            title: i18next.t("Dados_Sanguineos"),
            icon: "mdi-water",
            to: "/tag/blood-details",
          },
          {
            title: i18next.t("Medicamentos"),
            icon: "mdi-pill",
            to: "/tag/medicaments",
          },
          {
            title: i18next.t("Doencas"),
            icon: "mdi-emoticon-sick",
            to: "/tag/diseases",
          },
          {
            title: i18next.t("Cart_Vacinacao"),
            icon: "mdi-needle",
            to: "/tag/vaccination",
          },
          {
            title: i18next.t("Prontuario_Medico"),
            icon: "mdi-clipboard-plus",
            to: "/tag/medical-record",
          },
          {
            title: i18next.t("Anexos"),
            icon: "mdi-file-document-multiple",
            to: "/tag/attachments",
          },
          {
            title: i18next.t("Outras_Informacoes"),
            icon: "mdi-information-variant",
            to: "/tag/informations",
          },
        ];

        this.menuAdminPessoa = [
          {
            title: i18next.t("Dados_Privados"),
            icon: "mdi-account-lock",
            to: "/privacy",
          },
          { title: "QR Codes", icon: "mdi-qrcode", to: "/qrcodes" },
          // {title: "Life Card", icon: "mdi-smart-card-outline", to: "/life-card"},
        ];

        this.menuAdminPet = [
          {
            title: i18next.t("Dados_Privados"),
            icon: "mdi-account-lock",
            to: "/pet/privacy",
          },
          { title: "QR Codes", icon: "mdi-qrcode", to: "/pet/qrcodes" },
          // {title: "Life Card", icon: "mdi-smart-card-outline", to: "/pet/life-card"},
        ];

        this.menuAdminTag = [
          {
            title: i18next.t("Dados_Privados"),
            icon: "mdi-account-lock",
            to: "/tag/privacy",
          },
          { title: "QR Codes", icon: "mdi-qrcode", to: "/qrcodes" },
          // {title: "Life Card", icon: "mdi-smart-card-outline", to: "/tag/life-card"},
        ];
      }
    },
  },
  computed: {
    isLogged() {
      return !!this.$store.state.auth.user.token;
    },
    menu() {
      const token = this.$store.state.auth.user.token;
      switch (this.$store.state.context) {
        case "pessoa":
          return token
            ? [...this.menuPessoa, ...this.menuAdminPessoa]
            : this.menuPessoa;
        case "pet":
          return token ? [...this.menuPet, ...this.menuAdminPet] : this.menuPet;
        case "tagFuncionario":
          return token ? [...this.menuTag, ...this.menuAdminTag] : this.menuTag;
      }
      return null;
    },
    store() {
      return this.$store.state;
    },
    getLogo() {
      return (screen, position) => {
        const context = this.$store.state.context;

        const prefs = this.$store.getters[context + "/prefs"];

        if (prefs && prefs[screen] && prefs[screen].menu) {
          const logo = prefs[screen].menu.logo.image[position];

          return !this.imgLogo ? null : this.imgLogo + "/" + logo + ".jpg";
        } else {
          return this.$store.state[context].status === 0 &&
            !this.$store.state[context].data.cliente
            ? null
            : "no image";
        }
      };
    },
    userData() {
      return (field) => {
        const context = this.$store.state.context;
        switch (field) {
          case "nome":
            return this.$store.state[context].data.nome;
          case "email":
            return context === "pessoa" || context === "tagFuncionario"
              ? this.$store.state[context].data.email
              : "";
          case "fotoPerfil":
            return this.$store.state[context].data.fotoPerfil === "::restrict::"
              ? "::restrict::"
              : this.$store.state.profileImageURL +
                  this.$store.state[context].data.fotoPerfil;
        }
      };
    },
    getAccounts() {
      return {
        pessoa: this.$store.state.auth.accounts.pessoa || [],
        pet: this.$store.state.auth.accounts.pet || [],
        tag: this.$store.state.auth.accounts.tag || [],
      };
    },
  },
  mounted() {
    this.onGetAccounts();
  },
  methods: {
    onGetAccounts() {
      if (!this.accountsUpdated && this.$store.state.auth.user.token) {
        this.$store.dispatch("auth/getAccounts", {
          token: this.$store.state.auth.user.token,
        });
        this.accountsUpdated = true;
      }
    },
    onLoginAccount(uid, type) {
      if (this.$store.state.auth.user.id !== uid) {
        this.$store.commit("setSnackbarLoading", {
          message: this.$t("conectando_conta"),
          status: true,
        });

        this.$store
          .dispatch("auth/loginAccount", {
            token: this.$store.state.auth.user.token,
            email: this.$store.state.auth.user.email,
            type,
            uid,
          })
          .then((res) => {
            this.$store.commit("setSnackbarLoading", {
              status: false,
            });

            this.$store.commit("pessoa/setData", {});
            this.$store.commit("pet/setData", {});
            this.$store.commit("tag/setData", {});
            this.$store.commit("tagFuncionario/setData", {});

            if (res.status === 200) {
              this.$store.commit("setContext", res.data.content.user.tipo);
              this.$store.commit(
                this.$store.state.context + "/setUID",
                res.data.content.user.uid
              );

              switch (this.$store.state.context) {
                case "pessoa":
                  this.$router.push("/");
                  break;
                case "pet":
                  this.$router.push("/pet");
                  break;
                case "tagFuncionario":
                  this.$router.push("/tag");
                  break;
              }

              setTimeout(() => location.reload(), 100);
            }
          })
          .catch(() => {});
      }
    },
    onLogout() {
      this.$store.dispatch("auth/logout");
      this.$store.commit("pessoa/setData", {});
      this.$store.commit("pet/setData", {});
      this.$store.commit("tag/setData", {});
      this.$store.commit("tagFuncionario/setData", {});
      this.$store.commit("auth/setAccounts", []);
      this.$router.push("/login");
    },
    getType(type) {
      switch (type) {
        case "pessoa":
          return this.$t("Bracelete");
        case "pet":
          return this.$t("Pingente");
        case "tagFuncionario":
          return "Tag";
      }
      return "";
    },
    getID(id) {
      return id.split("/")[2];
    },
    onChangeLanguage(lang) {
      this.$store.commit("setLanguage", lang);
    },
  },
};
</script>

<style lang="scss">
.menu-item {
  border-bottom: solid 1px #e6e6e6;
}

.side-menu {
  .v-navigation-drawer__border {
    background-color: transparent !important;
  }

  .theme--light.v-list-item--active:before,
  .theme--light.v-list-item--active:hover:before,
  .theme--light.v-list-item:focus:before {
    background-color: #dd7070;
  }

  .v-list .v-list-item--active,
  .v-list .v-list-item--active .v-icon {
    color: #e57373;
  }

  .theme--light.v-btn:hover {
    &:before {
      opacity: 0.12 !important;
      background-color: #dd7070;
    }

    .v-btn__content {
      color: #e57373 !important;

      .v-icon {
        color: #e57373 !important;
      }
    }
  }

  .v-btn .v-ripple__animation,
  .v-list .v-ripple__animation {
    background: #dd7070 !important;
  }

  .v-avatar {
    border: solid 1px #e5e5e5;
  }
}
</style>
